const locale = {
	notice_board: 'お知らせページ',
	staff_schedule_title: '編集・登録',
	edit_staff_schedule : '職員予定',
	staff_schedule: '職員予定 ',
	today: '今日',
	back_to_notices_list: 'Back to notices list',
	create_staff:'登録',
	mix_calendar:'現場・職員予定',
	view_notice_event:'お知らせの詳細',
	create_notice:"編集・登録",
	create:'登録',
	update_notice:"更新",
	select_project:'現場一覧',
	permission:'公開対象',
	expired_date:'掲載期限',
	edit:'編集',
	posted:'掲載日',
	user:'ユーザー名',
	content:'内容',
	read_by:'既読数',
	flag_as_important:'重要マーク',
	cancel:'キャンセル',
	delete:'削除',
	submit:'登録',
	update:'更新',
	enter_valid_date:'有効な日付を入力してください',
	date_should_not_be_before_todays_date: '今日以降の日付を入力してください',
	drag_n_drop_some_files_here_or_click_to_select_files: 'ファイルをドロップ、もしくはクリックして選択してください',
	please_enter_a_valid_url: '有効なURLを入力してください',

	details:'詳細',
	name: '名前',
	aqua: '薄青',
	lemon: '薄黄',
	olive: '薄緑',
	crimson: '薄紅',
	lilac: '薄紫',
	gray: '灰',
	crepe: '薄桃',
	sage: '薄黄緑',
	blush: '薄赤',
	royal_blue: '薄紺',
	title: 'タイトル',
	all_day:'終日',
	go_direct: '直行',
	return_direct: '直帰',
	to: 'から',
	repeat:'繰り返し',
	until: '終了日',
	interval:'間隔',
	select:'曜日を選択 ',
	daily: '毎日',
	weekly: '毎週',
	monthly: '毎月',
	yearly:'毎年',
	custom: 'カスタム',
	week: '週 ',
	month: '月',
	year: '年',
	mon:'月',
	tue: '火',
	wed:'水',
	thu:'木',
	fri:'金',
	sat:'土',
	sun:'日',
	monday:'月曜日',
	tuesday: '火曜日',
	wednesday:'水曜日',
	thursday:'木曜日',
	friday:'金曜日',
	saturday:'土曜日',
	sunday:'日曜日',
	last:'先週の',
	start_time: '開始時間',
	end_time: '終了時間',
	please_select_an_option:'オプションを選んでください',
	show_more: 'もと見る',
	delete_this_staff_event: 'イベントを削除',

	view_staff_schedule_title: '職員予定',
	created_by: '作成者',
	start_date: '開始日',
	dashboard: 'ダッシュボード',
	repeat_every: '',

	max: '最高',
	min: '最低',
	feels_like: '体感温度',
};

export default locale;
